import { Geokoordinaten } from './geokoordinaten';
import { Netzbetreiber } from './netzbetreiber';

export class Netzzuordnung {
    public netzzuordnungId: string;
    public stationsname: string;
    public trafoFeldNummer: string;
    public trafoFeldName: string;
    public ortsschluessel: string;
    public ortsname: string;
    public stationsnummer: string;
    public netzbetreiber: Netzbetreiber;
    public leitstellenRegion: string;
    public uuid?: string;
    public uuidDatum: string;
    public geokoordinaten: Geokoordinaten;
    public deactivated: boolean;
    public netzgruppe: string;
}
